import React from 'react'
import { Button, Modal, Spin, Modal as AntdModal } from 'antd'
import styles from './styles.module.css'

type Props = {
  isOpen: boolean
  onClose: () => void
  title: string
  mode?: 'create' | 'edit'
  creatorEmail?: string
  isLoading?: boolean
  isSubmitting?: boolean
  isDeleting?: boolean
  onSubmit: () => void
  onSubmitAndCreateNew?: () => void
  onDelete?: () => void
  width?: number | string
  children: React.ReactNode
}

export const TransactionModalLayout: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  mode = 'create',
  creatorEmail,
  isLoading = false,
  isSubmitting = false,
  isDeleting = false,
  onSubmit,
  onSubmitAndCreateNew,
  onDelete,
  width = 720,
  children,
}) => {
  const handleDelete = () => {
    if (!onDelete) return
    AntdModal.confirm({
      title: 'Удалить транзакцию?',
      content: 'Это действие нельзя отменить.',
      okText: 'Удалить',
      okType: 'danger',
      cancelText: 'Отмена',
      onOk: onDelete,
    })
  }

  const submitDisabled = isLoading || isSubmitting || isDeleting

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={title}
      width={width}
      destroyOnHidden
      maskClosable={!isSubmitting && !isDeleting}
      className={styles.modal}
      footer={
        isLoading
          ? null
          : [
              <p key="creator" className={styles.creator}>
                {creatorEmail ? (
                  <>
                    <span className={styles.creatorLabel}>Created by </span>
                    {creatorEmail}
                  </>
                ) : null}
              </p>,
              <div key="actions" className={styles.actions}>
                {mode === 'edit' && onDelete && (
                  <Button
                    danger
                    onClick={handleDelete}
                    loading={isDeleting}
                    disabled={isSubmitting}
                  >
                    Delete
                  </Button>
                )}
                {mode === 'create' && onSubmitAndCreateNew && (
                  <Button
                    onClick={onSubmitAndCreateNew}
                    loading={isSubmitting}
                    disabled={submitDisabled}
                  >
                    Add and create new
                  </Button>
                )}
                <Button
                  type="primary"
                  onClick={onSubmit}
                  loading={isSubmitting}
                  disabled={submitDisabled}
                >
                  {mode === 'edit' ? 'Save' : 'Add transaction'}
                </Button>
              </div>,
            ]
      }
    >
      {isLoading ? (
        <div className={styles.spinnerWrapper}>
          <Spin size="large" />
        </div>
      ) : (
        children
      )}
    </Modal>
  )
}
